// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"mask-text-field_wrapper__kgZgR","label":"mask-text-field_label__DcSJD","input":"mask-text-field_input__tQDUA","error":"mask-text-field_error__gZoIj"};